import { render, staticRenderFns } from "./CardLiteratureList.vue?vue&type=template&id=a0558fcc&scoped=true"
import script from "./CardLiteratureList.vue?vue&type=script&lang=js"
export * from "./CardLiteratureList.vue?vue&type=script&lang=js"
import style0 from "./CardLiteratureList.vue?vue&type=style&index=0&id=a0558fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0558fcc",
  null
  
)

export default component.exports